import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
interface InvoiceGeneratorProps {
  orderDetails: {
    customerName: string;
    estimate: string;
    address: string;
    date: string;
    billToEmail: string;
    primaryContact: string;
  };
  status: 'unpaid' | 'paid';
  onGenerate?: () => void;
}
export const InvoiceGenerator: React.FC<InvoiceGeneratorProps> = ({
  orderDetails,
  status = 'unpaid',
  onGenerate
}) => {
  const [invoice, setInvoice] = useState({
    orderNumber: `ORD-${Math.floor(Math.random() * 10000)}`,
    amountOwed: orderDetails.estimate.replace('$', ''),
    billToEmail: orderDetails.billToEmail,
    primaryContact: orderDetails.primaryContact,
    invoiceSentDate: new Date().toISOString().split('T')[0],
    invoiceReceivedDate: '',
    status: status
  });
  const [copied, setCopied] = useState(false);
  const handleChange = (field: string, value: string) => {
    setInvoice(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleCopyInvoice = () => {
    const invoiceText = `
Order Number: ${invoice.orderNumber}
Amount Owed: $${invoice.amountOwed}
Bill To Email: ${invoice.billToEmail}
Primary Contact: ${invoice.primaryContact}
Invoice Sent: ${invoice.invoiceSentDate}
Invoice Received: ${invoice.invoiceReceivedDate}
    `.trim();
    navigator.clipboard.writeText(invoiceText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const handleGenerateInvoice = () => {
    handleCopyInvoice();
    onGenerate?.();
  };
  return <div className="space-y-6" data-id="element-32">
      <div className="flex items-center justify-between mb-4" data-id="element-33">
        <div className="flex items-center gap-2" data-id="element-34">
          <span className="text-sm font-medium" data-id="element-35">Status:</span>
          <span className={`text-sm px-2 py-1 rounded-full ${status === 'paid' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-36">
            {status === 'paid' ? 'Paid' : 'Unpaid'}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-37">
        <div data-id="element-38">
          <label className="block text-sm font-medium mb-1" data-id="element-39">Order Number</label>
          <input type="text" value={invoice.orderNumber} readOnly className="w-full px-3 py-2 border rounded-md bg-muted" data-id="element-40" />
        </div>
        <div data-id="element-41">
          <label className="block text-sm font-medium mb-1" data-id="element-42">Amount Owed</label>
          <div className="relative" data-id="element-43">
            <span className="absolute left-3 top-2" data-id="element-44">$</span>
            <input type="text" value={invoice.amountOwed} onChange={e => handleChange('amountOwed', e.target.value)} className="w-full px-3 py-2 pl-6 border rounded-md" data-id="element-45" />
          </div>
        </div>
        <div data-id="element-46">
          <label className="block text-sm font-medium mb-1" data-id="element-47">
            Bill To Email
          </label>
          <input type="email" value={invoice.billToEmail} onChange={e => handleChange('billToEmail', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="client@example.com" data-id="element-48" />
        </div>
        <div data-id="element-49">
          <label className="block text-sm font-medium mb-1" data-id="element-50">
            Primary Contact
          </label>
          <input type="text" value={invoice.primaryContact} onChange={e => handleChange('primaryContact', e.target.value)} className="w-full px-3 py-2 border rounded-md" data-id="element-51" />
        </div>
        <div data-id="element-52">
          <label className="block text-sm font-medium mb-1" data-id="element-53">
            Invoice Sent Date
          </label>
          <input type="date" value={invoice.invoiceSentDate} onChange={e => handleChange('invoiceSentDate', e.target.value)} className="w-full px-3 py-2 border rounded-md" data-id="element-54" />
        </div>
        <div data-id="element-55">
          <label className="block text-sm font-medium mb-1" data-id="element-56">
            Invoice Received Date
          </label>
          <input type="date" value={invoice.invoiceReceivedDate} onChange={e => handleChange('invoiceReceivedDate', e.target.value)} className="w-full px-3 py-2 border rounded-md" data-id="element-57" />
        </div>
      </div>
      <button onClick={handleGenerateInvoice} className="w-full md:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors" data-id="element-58">
        {copied ? <Check className="w-4 h-4" data-id="element-59" /> : <Copy className="w-4 h-4" data-id="element-60" />}
        {copied ? 'Copied!' : 'Copy Invoice Details'}
      </button>
    </div>;
};